module.exports = __webpack_public_path__ + "static/media/pamain-light.096bcef1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pamain-light.ttf
// module id = ./src/assets/fonts/pamain-light.ttf
// module chunks = 6